var _defs, _circle, _rect, _rect2, _rect3, _rect4, _circle2, _path, _path2, _g, _path3, _g2, _rect5, _rect6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSherlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.04 346.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2385c6;}.cls-2{fill:#f7cc31;}.cls-11,.cls-3{fill:#fff;}.cls-3,.cls-9{opacity:0.5;}.cls-4{fill:#f58622;}.cls-5{opacity:0.2;}.cls-6{opacity:0.1;}.cls-7{fill:#03638d;}.cls-8{fill:#3457a6;}.cls-9{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.cls-10{fill:#499ad4;opacity:0.12;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixelcities_elements") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.81,
    cy: 107.57,
    r: 45
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.81,
    y: 75.33,
    width: 160.54,
    height: 68.24,
    rx: 3.96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.3,
    y: 98.61,
    width: 84.73,
    height: 3.84
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.3,
    y: 108.73,
    width: 84.73,
    height: 3.84
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.3,
    y: 119.92,
    width: 45.8,
    height: 3.84
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97.23,
    cy: 107.99,
    r: 36.41,
    transform: "translate(-46.09 131.98) rotate(-57.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.4,101.27l-.14-21.2a27.08,27.08,0,0,0-17.48,6.82,25.08,25.08,0,0,0-8.43,22,29,29,0,0,0,.5,3.08s0,0,0,.07h0l25.54-5.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.72,94.74a25.16,25.16,0,0,0-20.61-14.43l-.81-.07-.51,0c-.51,0-1,0-1.54,0h-.14l.14,21.19,0,5,25.54,5.57h0a25.14,25.14,0,0,0,.56-5.49A27.47,27.47,0,0,0,121.72,94.74Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.72,94.74a25.16,25.16,0,0,0-20.61-14.43l-.81-.07-.51,0c-.51,0-1,0-1.54,0h-.14l.14,21.19,0,5,25.54,5.57h0a25.14,25.14,0,0,0,.56-5.49A27.47,27.47,0,0,0,121.72,94.74Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.77,108.89l-25.54,5.75a26.18,26.18,0,0,0,51.12-.18L96.8,108.89"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.77,108.89l-25.54,5.75a26.18,26.18,0,0,0,51.12-.18L96.8,108.89"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 110.73,
    y: 150.78,
    width: 20.45,
    height: 8.77,
    transform: "translate(202.95 -23.68) rotate(62.57)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.64,
    y: 150.78,
    width: 8.64,
    height: 8.77,
    transform: "translate(202.95 -23.68) rotate(62.57)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137,160.91A4.51,4.51,0,0,0,130.9,159l-13.41,7a4.51,4.51,0,0,0-1.92,6.08l23.26,44.37L160.1,205Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.08,212.67l-4-7.67-21.27,11.4,3.84,7.38a4.49,4.49,0,0,0,6.07,1.92l13.41-7A4.51,4.51,0,0,0,164.08,212.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.49,166l6-3.12,25.22,48.26-9.9,5.31L115.57,172A4.51,4.51,0,0,1,117.49,166Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.74,222.59l-6,3.11a4.51,4.51,0,0,1-6.08-1.92l-3.83-7.38,9.9-5.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.94,94.28a45.41,45.41,0,1,0,57-29.58A45.41,45.41,0,0,0,53.94,94.28ZM62.51,97a36.41,36.41,0,1,1,23.72,45.71A36.42,36.42,0,0,1,62.51,97Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M102.5,80.06c-10.91-3.69-32.65,4.65-35.18,24.88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M62.62,119.3c24.2,15.69,53.43,7.74,71-11.13a36.46,36.46,0,0,1-40,36.06,37.44,37.44,0,0,1-7.4-1.52A36.39,36.39,0,0,1,62.62,119.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.23,142.7A36.37,36.37,0,0,0,131.94,119a36.34,36.34,0,0,0,1.71-10.81,61.92,61.92,0,0,0,7.82-10.4,45.41,45.41,0,1,1-89.6,12.56,60.86,60.86,0,0,0,10.75,9A36.35,36.35,0,0,0,86.23,142.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M56.73,94.88A42,42,0,1,0,109.5,67.49,42,42,0,0,0,56.73,94.88Zm8.42,2.67a33.2,33.2,0,1,1,21.63,41.67A33.2,33.2,0,0,1,65.15,97.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.81,187.51l-7.49-85.3s35.68,24,39.33,65.61-16.38,61.38-16.38,61.38l-13.54,1.19Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.08,178.33l63.67-57.24S287,164,256,192,197,215.75,197,215.75L188,205.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.89,185.9l82-24.6s-16.24,39.79-56.29,51.8-63.43-3.61-63.43-3.61l-3.9-13Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.91,194.23l84.44,14.22S281.18,237,240,230s-55.29-31.3-55.29-31.3l2.26-13.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M224.61,224.42l24.75,42.46s-53.31-6.38-64.65-39-9.55-52-26.39-50.55l-34.19,3.85a.5.5,0,0,1-.16-1l48.17-11.39s16.26-4,23.32,5S224.61,224.42,224.61,224.42Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "144.05 188.86 124.44 184.32 141.94 180.11 144.05 188.86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSherlock);
export default __webpack_public_path__ + "static/media/sherlock.2da31643ba4abf0686c11cce3d8b43f3.svg";
export { ForwardRef as ReactComponent };